import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

// Ensure the id route parameter is a valid number
export const strategicAreaIdGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const idString = route.paramMap.get('id');

  // Reject null/empty/whitespace values
  if (idString === null || idString.trim() === '') {
    return router.createUrlTree(['/admin/authorization']);
  }

  const id = Number(idString);

  // If the id parameter is not a valid number, redirect back to strategic areas
  if (Number.isNaN(id) || !Number.isInteger(id) || id < 0) {
    return router.createUrlTree(['/admin/authorization']);
  }

  return true;
};
